/*
 * The original Prestige selectors remain in place (and keep handling variant,
 * price, inventory, gallery and cart state). These visible controls simply
 * invoke that tested selector API, so apps relying on it continue to work.
 */
(function () {
  'use strict';

  function matchingValueButton(root, position, value) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-action="select-value"][data-option-position]')).filter(function (button) {
      return button.getAttribute('data-option-position') === position && button.getAttribute('data-value') === value;
    })[0];
  }

  function syncPicker(root, position, value) {
    Array.prototype.forEach.call(root.querySelectorAll('.VariantPicker__Button[data-option-position="' + position + '"]'), function (button) {
      var selected = button.getAttribute('data-option-value') === value;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (event) {
    var pickerButton = event.target.closest('.VariantPicker__Button');
    if (pickerButton) {
      event.preventDefault();
      var form = pickerButton.closest('.ProductForm');
      var position = pickerButton.getAttribute('data-option-position');
      var value = pickerButton.getAttribute('data-option-value');
      var section = form && form.closest('[data-section-id]');
      var originalButton = section && matchingValueButton(section, position, value);

      if (originalButton) {
        originalButton.click();
        syncPicker(form, position, value);
        pickerButton.closest('.VariantPicker').querySelector('[data-variant-picker-selected]').textContent = value;
      }
      return;
    }

    var original = event.target.closest('[data-action="select-value"][data-option-position]');
    if (original) {
      var productForm = original.closest('[data-section-id]') && original.closest('[data-section-id]').querySelector('.ProductForm');
      if (productForm) {
        syncPicker(productForm, original.getAttribute('data-option-position'), original.getAttribute('data-value'));
        var picker = productForm.querySelector('.VariantPicker__Button[data-option-position="' + original.getAttribute('data-option-position') + '"][data-option-value="' + original.getAttribute('data-value') + '"]');
        if (picker) {
          picker.closest('.VariantPicker').querySelector('[data-variant-picker-selected]').textContent = original.getAttribute('data-value');
        }
      }
    }
  });
}());
